<template>
  <div v-if="isMobileDevice" class="footer-wrap">
    <div class="footer-alarm" v-if="noticeList.length > 0">
      <span class="footer-alarm-icon">
        <router-link to="customer/notice_list">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0h24v24H0z"/>
              <path fill="#A5A5A5" d="M8.286 15.96h-.763a3.523 3.523 0 1 1 0-7.046h6.558l4.386-2.76A1 1 0 0 1 20 7.002v10.66a1 1 0 0 1-1.45.892L13.4 15.96h-3.113l1.533 5.404a.5.5 0 0 1-.48.636h-.961a.5.5 0 0 1-.481-.363L8.286 15.96z"/>
              <circle cx="22" cy="2" r="2" fill="#E938C6"/>
            </g>
        </svg>
        </router-link>
       </span>
        <swiper :options="swiperOptions" ref="footerNotice" @click.native="goNotice()">
          <swiper-slide v-for="(notice, index) in noticeList" :key="'footer_notice'+ index">
            <span class="footer-alarm-txt"> {{notice.bottom_text1}} </span>
          </swiper-slide>
        </swiper>
    </div>

    <footer>
      <div class="footer-icon">
        <a href="https://www.facebook.com/wavve.official/" target="_blank">
          <span class="footer-icon-img facebook"></span>
          <span class="a11y-hidden">페이스북 바로가기</span>
        </a>
        <a href="http://m.post.naver.com/my.nhn?memberNo=12375258">
          <span class="footer-icon-img naver"></span>
          <span class="a11y-hidden">네이버 포스트 바로가기</span>
        </a>
      </div>
      <div class="footer-info">
        <ul class="footer-info-list">
          <li><router-link to="/agreement/service">이용약관</router-link></li>
          <li><router-link to="/agreement/privacy">개인정보처리방침</router-link></li>
          <li><router-link to="/customer/faq">고객센터</router-link></li>
        </ul>
        <p class="copyright">
          <span>Copyright© 콘텐츠웨이브(주)</span>
          <span>통신판매업 신고번호 제 2015-서울마포-0128호</span>
          <span>All rights reserved.</span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { FooterNoticeSerivce } from '@/common/api/api.service'
import { get } from 'lodash'
import utils from '@/common/util/utils'

export default {
  name: 'Footer',
  data: () => {
    return {
      noticeList: [],
      swiperOptions: {
        allowTouchMove: false,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        slidesPerView: 1
      }
    }
  },
  methods: {
    goNotice () {
      const swiperIndex = this.$refs.footerNotice.swiper.clickedSlide.dataset.swiperSlideIndex
      const noticeNumber = this.noticeList[swiperIndex].bottom_link.split('=').pop()
      this.$router.push(`/customer/notice_view/${noticeNumber}`)
    }
  },
  computed: {
    isMobileDevice () {
      return utils.cookies.getDevice() === 'mobile'
    }
  },
  created () {
    FooterNoticeSerivce.getNotices().then(({ data }) => {
      this.noticeList = get(data, ['top_list', '0', 'bottom_list'], [])
    })
  }
}
</script>

<style scoped>

  /*------------------------------------*\
      footer
  \*------------------------------------*/
  .footer-wrap{
    margin-top: -70px;
    margin-bottom: 30px
  }

  /* footer info 상단 알림 메뉴*/
  .footer-alarm{
    padding: 9px 10px;
    background-color: #161616;
  }
  .footer-alarm a{
    display: block;
    width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 13px;
    color: #23212a
  }
  .footer-alarm-icon,
  .footer-alarm-txt{
    display: inline-block;
    vertical-align: middle;
  }
  .footer-alarm-icon {
    position: absolute;
  }

  /* footer info 아이콘 링크 */
  .footer-icon{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .footer-icon a{
    display: block;
    margin: 30px 5px 20px;
  }
  .footer-icon-img{
    display: block;
    content: '';
    width: 38px;
    height: 38px;
    background-color: #1abc9c
  }
  .footer-icon-img.facebook{
    background: url(/img/common/footer-icon-facebook.png);
    background-size: 38px 38px
  }
  .footer-icon-img.naver{
    background: url(/img/common/footer-icon-naver.png);
    background-size: 38px 38px
  }
  .footer-icon-img.youtube{
    background: url(/img/common/footer-icon-youtube.png);
    background-size: 38px 38px
  }

  /* footer info 아이콘 링크 하단 */
  .footer-info-list{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .footer-info-list li{
    padding-left: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 14px;
  }
  .footer-info-list li:nth-child(1):after,
  .footer-info-list li:nth-child(2):after{
    display: inline-block;
    vertical-align: middle;
    content: '';
    width: 1px;
    height: 9px;
    margin-left: 10px;
    background-color: #3e3e3e;
  }
  .footer-info-list a{
    display: inline-block;
    font-size: 12px;
    line-height: 13px;
    color: #5e5e5e;
  }
  .copyright{
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #5e5e5e;
  }
  .copyright span{
    display: block;
  }
  span.footer-alarm-txt{
    margin-top: 3px;
    position: absolute;
    font-size: 12px;
    color: #a5a5a5;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .swiper-container {
    position: relative;
    width: 100%;
    height: 24px;
    padding-left: 34px;
  }
</style>
